<div class="my-7 px-4" role="main">
  <div class="text-center">
    <svg
      width="138px"
      height="132px"
      viewBox="0 0 138 132"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>error_pages/icons/server</title>
      <defs>
        <path
          d="M14.0169955,69.966009 C21.7103762,69.966009 27.9408199,76.2450668 27.9408199,83.9830045 C27.9408199,91.7209422 21.7103762,98 14.0169955,98 C6.32361484,98 0.0931711307,91.7209422 0.0931711307,83.9830045 C0.0931711307,76.2450668 6.32361484,69.966009 14.0169955,69.966009 Z M14.0169955,73.9317931 C8.52078652,73.9317931 4.05895522,78.4284386 4.05895522,83.9830045 C4.05895522,89.5375704 8.52078652,94.0342159 14.0169955,94.0342159 C19.5132045,94.0342159 23.9750358,89.5375704 23.9750358,83.9830045 C23.9750358,78.4284386 19.5132045,73.9317931 14.0169955,73.9317931 Z M26.051099,4.8316906e-13 C27.14622,4.8316906e-13 28.033991,0.887771009 28.033991,1.98289205 L28.033991,1.98289205 L28.033991,61.6875537 C28.033991,62.7826747 27.14622,63.6704457 26.051099,63.6704457 L26.051099,63.6704457 L1.98289205,63.6704457 C0.887771009,63.6704457 -1.73140958e-11,62.7826747 -1.73140287e-11,61.6875537 L-1.73140287e-11,61.6875537 L-1.73103728e-11,1.98289205 C-1.73103058e-11,0.887771009 0.887771009,4.8316906e-13 1.98289205,4.8316906e-13 L1.98289205,4.8316906e-13 Z M24.0681157,3.96629253 L3.96555617,3.96629253 L3.96555617,59.704066 L24.0681157,59.704066 L24.0681157,3.96629253 Z"
          id="path-1"
        ></path>
        <linearGradient x1="50%" y1="-2.48949813e-15%" x2="50%" y2="100%" id="linearGradient-3">
          <stop stop-color="#8017E1" offset="0%"></stop>
          <stop stop-color="#39006B" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g id="error_pages/icons/server" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="server3" transform="translate(55.000000, 17.000000)">
          <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"></use>
          </mask>
          <use id="Mask" fill="#3E54A4" fill-rule="nonzero" xlink:href="#path-1"></use>
          <rect
            id="primary-gradient-vert"
            fill="url(#linearGradient-3)"
            mask="url(#mask-2)"
            x="-55"
            y="-19"
            width="141.891892"
            height="139.864865"
          ></rect>
        </g>
      </g>
    </svg>
  </div>

  <h1>{{ heading }}</h1>
  <h3>{{ subHeading }}</h3>
  <p>
    We're experiencing a temporary outage. Wait a few minutes and try reloading the page. And thanks for your patience.
  </p>

  <p class="text-muted mt-4">Error: 503</p>
</div>
